import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const toast = {
  success: (title: string) => Toast.fire({ icon: 'success', title, timer: 3000 }),
  error: (title: string) => Toast.fire({ icon: 'error', title, timer: 5000 }),
  warning: (title: string) => Toast.fire({ icon: 'warning', title, timer: 4000 }),
  info: (title: string) => Toast.fire({ icon: 'info', title, timer: 4000 }),
};

export async function swalConfirm(opts: {
  title: string;
  text?: string;
  html?: string;
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
}): Promise<boolean> {
  const result = await Swal.fire({
    title: opts.title,
    ...(opts.html ? { html: opts.html } : { text: opts.text }),
    icon: 'question',
    showCancelButton: opts.showCancel ?? true,
    confirmButtonText: opts.confirmText ?? 'Confirm',
    cancelButtonText: opts.cancelText ?? 'Cancel',
    confirmButtonColor: 'hsl(74 40% 40%)',
    cancelButtonColor: 'hsl(74 15% 45%)',
    reverseButtons: true,
    allowOutsideClick: false,
    customClass: { popup: 'rounded-xl' },
  });
  return result.isConfirmed;
}

export async function confirmDelete(name: string): Promise<boolean> {
  const result = await Swal.fire({
    title: 'Delete confirmation',
    html: `Are you sure you want to delete <strong>${name}</strong>? This action cannot be undone.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete',
    cancelButtonText: 'Cancel',
    confirmButtonColor: 'hsl(0 84% 60%)',
    cancelButtonColor: 'hsl(74 15% 45%)',
    reverseButtons: true,
    focusCancel: true,
    allowOutsideClick: false,
    customClass: { popup: 'rounded-xl' },
  });
  return result.isConfirmed;
}
